import(/* webpackMode: "eager", webpackExports: ["RegistrationWrapper"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/RegistrationWrapper/text.tsx");
